import axios from 'axios';

// `lodash.get` with a dotted path resolves to lodash's `any` overload, and this repo has no
// backstop for that: tsconfig is non-strict, no-unsafe-* is not extended, and lint runs --quiet.
type BeErrorBody = { readonly showBeMessage?: unknown; readonly message?: unknown };

const MAX_MESSAGE_LENGTH = 500;

export const getBeErrorMessage = (error: unknown): string | undefined => {
  if (!axios.isAxiosError<BeErrorBody>(error)) return undefined;

  const { showBeMessage, message } = error.response?.data ?? {};

  if (showBeMessage !== true) return undefined;

  if (typeof message !== 'string' || message.trim().length === 0) {
    return undefined;
  }

  return message.length > MAX_MESSAGE_LENGTH ? message.slice(0, MAX_MESSAGE_LENGTH) : message;
};
